<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <h1 class="text-black title-6 md:title-3">Logs y auditoría</h1>

    <div class="flex flex-col items-center justify-center w-full pt-3 pb-5 md:flex-row md:gap-5">
        <mat-form-field appearance="fill" class="w-full md:flex-1 mt-6">
            <input
                matInput
                type="text"
                placeholder="Usuario/N° folio pagaré"
                class="py-[18px]"
                [(ngModel)]="search"
                [patterns]="customPatterns"
                [dropSpecialCharacters]="false"
                mask="0*"
                maxlength="30"
                (keyup.enter)="buscarAudit()" />
            <mat-icon class="w-[16.67px] h-[15px] min-w-[16.67px] min-h-[15px] cursor-pointer" svgIcon="icons:buscar-icon" (click)="buscarAudit()"> </mat-icon>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full md:w-72">
            <mat-label class="px-1"
                >Desde &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                Hasta</mat-label
            >
            <mat-date-range-input [rangePicker]="picker" class="py-[15px] title-9 font-semibold">
                <input matStartDate placeholder="Fecha inicio" [(ngModel)]="start" #dateRangeStart />
                <input
                    matEndDate
                    placeholder="Fecha fin"
                    [(ngModel)]="end"
                    #dateRangeEnd
                    (dateChange)="dateRangeChange($event, dateRangeStart, dateRangeEnd)" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>

    <app-mat-custom-table (action)="onTableAction($event)" [use_selection]="false" [use_detail]="true" [dataset]="dataSource" [columns]="columns">
    </app-mat-custom-table>

    <div class="grid grid-cols-1 gap-5 pt-5 md:px-5 md:grid-cols-2 md:gap-0">
        <button mat-flat-button color="primary" class="w-full transition-all duration-300 ease-in-out md:w-36" (click)="descargarExcel()">
            Descargar Logs
        </button>
    </div>
</main>

<div *ngIf="showModalDetail" class="fixed inset-0 grid w-full h-full py-5 bg-opacity-50 bg-primary-black-01 z-99999 place-items-center">
    <div
        class="w-full max-w-[900px] h-full max-h-[700px] bg-primary-white-01 rounded-2xl px-10 py-10 md:px-10 md:py-12 gap-5 relative overflow-y-scroll no-scrollbar">
        <button
            class="absolute top-3 right-3 md:right-14 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="closeModalDetalle()">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>

        <div
            *ngIf="detalleOriginal"
            class="flex flex-col items-center w-full p-4 mb-2 overflow-y-scroll border rounded-lg border-primary-blue-01 no-scrollbar">
            <p class="title-8 text-primary-black-01">Datos orginales</p>
            <p class="mt-1 break-all paragraph-5 text-primary-black-01">{{ detalleOriginal }}</p>
        </div>

        <div class="flex flex-col items-center w-full p-4 overflow-y-scroll border rounded-lg border-primary-blue-01 no-scrollbar">
            <p class="title-8 text-primary-black-01">Datos nuevos</p>
            <p class="mt-1 break-all paragraph-5 text-primary-black-01">{{ detalleNuevo }}</p>
        </div>
    </div>
</div>
